import { useCallback, useMemo } from 'react'
import { dataUnready } from '~/lib/helpers/dataUnready'
import { formatAlert } from '~/lib/helpers/formatAlert'
import PropTypes from 'prop-types'

// Static alert model
const ALERT_MODEL = {
  title: '{count} mySCP Complete (query|queries)',
  url: '/chartviewer/complete'
}

function AlertsItem ({ count, handleAlertClick, tag: Tag }) {
  const formattedAlert = useMemo(() => formatAlert({ count }, ALERT_MODEL), [count])

  const handleClick = useCallback(() => {
    handleAlertClick(formattedAlert.url)
  }, [handleAlertClick])

  return (
    <Tag title={formattedAlert.title} handleClick={handleClick} />
  )
}

function EpfAlerts ({ data, tag, handleAlertClick }) {
  const { unready, contact } = dataUnready(data, 'contact')
  let results = null

  if (!unready && contact && contact.deficiencies) {
    let epfCount = 0

    for (const facility of contact.deficiencies) {
      epfCount += facility.encounters.length
    }

    if (epfCount > 0) {
      results = <AlertsItem count={epfCount} handleAlertClick={handleAlertClick} tag={tag} />
    }
  }

  return results
}

EpfAlerts.propTypes = {
  data: PropTypes.object,
  tag: PropTypes.func,
  handleAlertClick: PropTypes.func
}

export default EpfAlerts
